import {Component} from '@angular/core';
import {InspectorImplementation, OpenTestMailEvent} from '../../../types';
import {ArtifactId, TestRunId} from '@webmate-web-core/shared/types/ids';
import {WorkbenchContextService} from '../../../services/workbench-context.service';
import {take} from 'rxjs/operators';
import {WorkbenchTestService} from '../../../services/workbench-test.service';
import {AddToFindingEvent} from '../inspector-shared-tools/add-to-finding.component';

@Component({
    selector: 'wm-testmail-inspector',
    templateUrl: './testmail-inspector.component.html',
    styleUrls: ['./testmail-inspector.component.less']
})
export class TestmailInspectorComponent implements InspectorImplementation {

    artifactId: ArtifactId;
    addedToFinding: boolean = false;
    activeTestRun?: TestRunId;

    constructor(private contextService: WorkbenchContextService,
                private workbenchTestService: WorkbenchTestService) {
    }

    ngOnInit() {
        this.contextService.subscribeWorkbenchContext$().subscribe(context => {
            this.activeTestRun = context?.testRunContext?.activeTestRun;
        })
    }

    handleInspectorEvent(event: OpenTestMailEvent): void {
        this.artifactId = event.mailArtifatId;
    }

    addToFinding(event: AddToFindingEvent) {
        this.workbenchTestService.addTestMailToFinding(event.findingId, this.artifactId, event.optDescription).pipe(take(1)).subscribe(() =>{
            this.addedToFinding = true;
            setTimeout(()=> this.addedToFinding = false, 5000);
        })
    }
}
